import React, { useEffect, useRef } from 'react';
import PropTypes from 'prop-types';
import errorBoundary from '@ifeng-fe/errorBoundary';
import Info from './info';
import { handleAd } from '@ifeng-fe/ui_pc_ad';
import { Event } from '@ifeng-fe/ui_base';
import styles from './index.css';

const Recommend = ({ content }) => {
    const container = useRef(null);
    const event = new Event();

    const dataInit = async () => {
        try {
            if (content.ad) {
                const callback = await handleAd(content.ad);

                callback(content.ad.data, event);

                event.trigger('init', { container: container.current });
            }
        } catch (e) {
            console.error(e);
        }
    };

    const getInfoList = () => {
        const info = content?.data?.slice(0, 16)?.map((item) => <Info key={item.id} data={item} count={item.count} />) || [];

        return info;
    };

    useEffect(() => {
        dataInit();
    }, []);

    return (
        <div className={styles.recommendBox} ref={container}>
            {getInfoList()}
        </div>
    );
};

Recommend.propTypes = {
    content: PropTypes.object,
};

export default errorBoundary(Recommend);
